import { Mail, Phone, Ban } from 'lucide-react'
import { TagPicker } from './TagPicker'
import { NotesSection } from './NotesSection'
import { CustomFieldsEditor } from './CustomFieldsEditor'

interface ClientStub {
  id: string
  displayName: string
  email: string | null
  phoneE164: string | null
  dnd: boolean
  dndEmail: boolean
  dndSms: boolean
  dndWhatsapp: boolean
  dndVoice: boolean
  marketingConsentEmail: boolean
  marketingConsentSms: boolean
  marketingConsentWhatsapp: boolean
  timezone: string
}

interface ConversationContextPanelProps {
  conversationId: string
  clientStub: ClientStub | null
}

export function ConversationContextPanel({
  conversationId,
  clientStub,
}: ConversationContextPanelProps) {
  if (!clientStub) {
    return (
      <aside className="w-72 shrink-0 border-l border-ink-900/10 bg-white p-4 text-xs text-ink-700/50">
        Sin cliente asociado.
      </aside>
    )
  }

  return (
    <aside className="w-72 shrink-0 border-l border-ink-900/10 bg-white overflow-auto">
      <div className="p-4 border-b border-ink-900/10">
        <div className="text-[10px] font-mono uppercase tracking-wider text-ink-700/60 mb-1">
          contacto
        </div>
        <div className="text-sm font-medium">{clientStub.displayName}</div>
        {clientStub.email && (
          <div className="mt-1 flex items-center gap-1.5 text-xs font-mono text-ink-700">
            <Mail className="size-3" />
            {clientStub.email}
          </div>
        )}
        {clientStub.phoneE164 && (
          <div className="mt-0.5 flex items-center gap-1.5 text-xs font-mono text-ink-700">
            <Phone className="size-3" />
            {clientStub.phoneE164}
          </div>
        )}
        <div className="mt-2 flex flex-wrap gap-1">
          {clientStub.dnd && (
            <span className="bp-pill bg-red-100 text-red-700">
              <Ban className="size-3 mr-0.5 inline" />
              DND global
            </span>
          )}
          {clientStub.dndEmail && <span className="bp-pill bg-red-50 text-red-700">no email</span>}
          {clientStub.dndSms && <span className="bp-pill bg-red-50 text-red-700">no sms</span>}
          {clientStub.dndWhatsapp && (
            <span className="bp-pill bg-red-50 text-red-700">no wa</span>
          )}
          {clientStub.dndVoice && <span className="bp-pill bg-red-50 text-red-700">no voice</span>}
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {clientStub.marketingConsentEmail && (
            <span className="bp-pill bg-emerald-50 text-emerald-700">consent email</span>
          )}
          {clientStub.marketingConsentSms && (
            <span className="bp-pill bg-emerald-50 text-emerald-700">consent sms</span>
          )}
          {clientStub.marketingConsentWhatsapp && (
            <span className="bp-pill bg-emerald-50 text-emerald-700">consent wa</span>
          )}
        </div>
        <div className="mt-2 font-mono text-[10px] text-ink-700/50">{clientStub.timezone}</div>
      </div>

      <div className="p-4 border-b border-ink-900/10">
        <TagPicker clientStubId={clientStub.id} />
      </div>

      <div className="p-4 border-b border-ink-900/10">
        <CustomFieldsEditor clientStubId={clientStub.id} />
      </div>

      <div className="p-4">
        <NotesSection conversationId={conversationId} />
      </div>
    </aside>
  )
}
